/*global Modernizr, Splide, ThemeSlideCurrentSlide, ThemeSlideHideArrows, ThemeSlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var homepage_slider = document.getElementById('homepage-slider');
    if(homepage_slider) {
      const slider = new Splide(homepage_slider, {
        type: 'loop',
        pagination: true,
        dots: true
      });

      slider.on('mounted', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.classList.add('page-less');
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.classList.remove('page-less');
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.mount({ ThemeSlideCurrentSlide, ThemeSlideHideArrows, ThemeSlideDisableDrag });
    }
}());
